module.exports = __webpack_public_path__ + "08_hair_gold.bf9bf46e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/08_hair_gold.png
// module id = u44o
// module chunks = 0